module.exports = __webpack_public_path__ + "img/top-bar.c13a9609.png";